
import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/61fb48c80e7a0eba6e6b69cd3e66a0d0.jpg)',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-24 lg:py-32">
        <div className="text-center">
          {/* Main Headline */}
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-4 sm:mb-6 leading-tight px-2">
            Generate Accurate MTA Quotes<br className="hidden sm:block" />
            <span className="text-amber-400">in Under 5 Minutes</span>
          </h1>

          {/* Subheadline */}
          <p className="text-lg sm:text-xl md:text-2xl text-gray-200 mb-8 sm:mb-10 max-w-4xl mx-auto leading-relaxed px-4">
            AI-powered material take-offs built for Australian tradies. Upload plans. Auto-calculate materials. Export branded quotes instantly.
          </p>

          {/* CTA Buttons - Mobile Optimized */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-10 sm:mb-12 px-4">
            <Link
              to="/signup"
              className="w-full sm:w-auto bg-amber-500 hover:bg-amber-600 text-black font-bold text-base sm:text-lg px-8 sm:px-10 py-4 sm:py-5 rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap touch-manipulation min-h-[56px] flex items-center justify-center"
            >
              Start Free Trial
            </Link>
            <Link
              to="/demo"
              className="w-full sm:w-auto bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white font-semibold text-base sm:text-lg px-8 sm:px-10 py-4 sm:py-5 rounded-lg border-2 border-white/30 transition-all duration-300 hover:border-white/50 whitespace-nowrap touch-manipulation min-h-[56px] flex items-center justify-center"
            >
              <i className="ri-play-circle-line mr-2 text-xl"></i>
              Watch 60s Demo
            </Link>
          </div>

          {/* Trust Bar - Mobile Optimized */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 max-w-5xl mx-auto px-4">
            <div className="flex items-center justify-center gap-3 bg-white/10 backdrop-blur-sm rounded-lg px-4 py-3 sm:py-4 border border-white/20">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-map-pin-line text-2xl text-amber-400"></i>
              </div>
              <span className="text-white font-medium text-sm sm:text-base whitespace-nowrap">Built for Australian Trades</span>
            </div>
            <div className="flex items-center justify-center gap-3 bg-white/10 backdrop-blur-sm rounded-lg px-4 py-3 sm:py-4 border border-white/20">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-time-line text-2xl text-amber-400"></i>
              </div>
              <span className="text-white font-medium text-sm sm:text-base whitespace-nowrap">Save 5+ Hours Per Week</span>
            </div>
            <div className="flex items-center justify-center gap-3 bg-white/10 backdrop-blur-sm rounded-lg px-4 py-3 sm:py-4 border border-white/20">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-file-pdf-line text-2xl text-amber-400"></i>
              </div>
              <span className="text-white font-medium text-sm sm:text-base whitespace-nowrap">Instant PDF Export</span>
            </div>
            <div className="flex items-center justify-center gap-3 bg-white/10 backdrop-blur-sm rounded-lg px-4 py-3 sm:py-4 border border-white/20">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-robot-line text-2xl text-amber-400"></i>
              </div>
              <span className="text-white font-medium text-sm sm:text-base whitespace-nowrap">AI-Powered Estimating</span>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce hidden sm:block">
        <i className="ri-arrow-down-line text-3xl text-white/60"></i>
      </div>
    </section>
  );
}
